<template>
    <div class="section mt-1">
        <ul class="nav nav-tabs lined" role="tablist">
            <li class="nav-item">
                <a class="nav-link active" data-bs-toggle="tab" href="javascript:void(0)" role="tab"
                    @click="goToTab('tabD')">
                    Report
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" href="javascript:void(0)" role="tab" @click="goToTab('tabP')">
                    Attendance
                </a>
            </li>
        </ul>
    </div>
    <div class="section text-center mt-1" v-if="loading">
        <div class="spinner-border text-primary" role="status"></div>
    </div>
    <!-- <div class="section pt-2" v-if="tabP && !loading">
        <div class="wallet-card mt-1">
            <div class="wallet-footer wallet-footer-user row">
                <div class="item col-6">
                    <router-link :to="'/meeting/' + this.$route.params.id + '/attendance-report'">
                        <a href="javascript:void(0)">
                            <div class="icon-wrapper back-color-blue1">
                                <ion-icon name="checkmark-done-outline"></ion-icon>
                                <strong class="menu-title mal-text">റിപ്പോർട്ട്</strong>
                            </div>
                        </a>
                    </router-link>
                </div>
                <div class="item col-6">
                    <router-link :to="'/meeting/' + this.$route.params.id + '/qr-code-generator'">
                        <a href="javascript:void(0)">
                            <div class="icon-wrapper back-color-blue1">
                                <ion-icon name="qr-code-outline"></ion-icon>
                                <strong class="menu-title mal-text">ക്യു ആർ കോഡ്</strong>
                            </div>
                        </a>
                    </router-link>
                </div>
            </div>
        </div>
    </div> -->
    <div v-if="tabP && !loading" class="cre-attendance-panel">
        <div class="attendance-summary">
            <div class="summary-chip summary-chip--present">
                <span class="summary-chip__value">{{ attendanceSummary.present }}</span>
                <span class="summary-chip__label">Present</span>
            </div>
            <div class="summary-chip summary-chip--absent">
                <span class="summary-chip__value">{{ attendanceSummary.absent }}</span>
                <span class="summary-chip__label">Absent</span>
            </div>
            <div class="summary-chip summary-chip--pending">
                <span class="summary-chip__value">{{ attendanceSummary.unmarked }}</span>
                <span class="summary-chip__label">Not marked</span>
            </div>
        </div>

        <div class="attendance-toolbar">
            <label class="attendance-toolbar__select">
                <input type="checkbox" class="cre-attendance-check" id="selectAllParticipants"
                    v-model="selectAllChecked" @change="toggleSelectAll">
                <span>Select all</span>
            </label>
            <span class="attendance-toolbar__count">{{ attendanceSummary.total }} students</span>
        </div>

        <div class="attendance-list">
            <div v-for="(member_list, index) in responseData.participants" :key="'p-' + member_list.id"
                class="student-card"
                :class="studentCardClass(member_list)"
                @click="toggleParticipantRow(member_list.id)">
                <label class="student-card__check" @click.stop>
                    <input type="checkbox" class="cre-attendance-check" :value="member_list.id"
                        v-model="selectedParticipants" :id="'participant_' + member_list.id">
                </label>
                <div class="student-card__avatar">
                    <img src="assets/img/sample/avatar/avatar1.png" alt="" class="student-card__avatar-img">
                    <span class="student-card__index">{{ index + 1 }}</span>
                </div>
                <div class="student-card__body">
                    <div class="student-card__row-top">
                        <span class="student-card__name">{{ member_list.name }}</span>
                        <span class="status-pill" :class="statusPillClass(member_list.attendance)">
                            {{ attendanceLabel(member_list.attendance) }}
                        </span>
                    </div>
                    <div class="student-card__row-bottom">
                        <span class="student-card__phone" v-if="member_list.mobile">
                            {{ member_list.country_code }} {{ member_list.mobile }}
                        </span>
                        <div class="student-card__actions" v-if="member_list.mobile || member_list.whatsapp" @click.stop>
                            <a v-if="member_list.mobile" :href="'tel:' + member_list.mobile" class="action-icon" aria-label="Call">
                                <ion-icon name="call-outline"></ion-icon>
                            </a>
                            <a v-if="member_list.whatsapp"
                                :href="'https://wa.me/' + member_list.whatsapp_country_code + member_list.whatsapp"
                                class="action-icon action-icon--whatsapp" aria-label="WhatsApp">
                                <ion-icon name="logo-whatsapp"></ion-icon>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="attendance-bulk-bar" :class="{ 'is-visible': selectedParticipants.length > 0 }">
            <span class="attendance-bulk-bar__count">{{ selectedParticipants.length }} selected</span>
            <div class="attendance-bulk-bar__actions">
                <button type="button" class="btn btn-present"
                    :disabled="batch_loading" @click="submitBatchAttendance('P')">
                    <span v-if="batch_loading" class="spinner-border spinner-border-sm"></span>
                    <span v-else>Present</span>
                </button>
                <button type="button" class="btn btn-absent"
                    :disabled="batch_loading" @click="submitBatchAttendance('A')">
                    Absent
                </button>
            </div>
        </div>
    </div>
    <div class="section mt-1" v-if="!loading && tabD">
        <Form @submit="reportDetailSave">
            <div class="card">
                <div class="card-body">
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label" for="pin">Date</label>
                            <Field type="date" class="form-control" name="cre_date" v-model="responseData.weekly_report.date"/>
                            <i class="clear-input">
                                <ion-icon name="close-circle"></ion-icon>
                            </i>
                        </div>
                        <ErrorMessage name="cre_date" class="error-feedback" />
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label" for="pin">Starting Time</label>
                            <Field type="time" class="form-control" name="starting_time" v-model="responseData.weekly_report.starting_time" />
                            <i class="clear-input">
                                <ion-icon name="close-circle"></ion-icon>
                            </i>
                        </div>
                        <ErrorMessage name="starting_time" class="error-feedback" />
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label" for="pin">Ending Time</label>
                            <Field type="time" class="form-control" name="ending_time" v-model="responseData.weekly_report.ending_time" />
                            <i class="clear-input">
                                <ion-icon name="close-circle"></ion-icon>
                            </i>
                        </div>
                        <ErrorMessage name="ending_time" class="error-feedback" />
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label" for="pin">Faculty Reporting Time</label>
                            <Field type="time" class="form-control" name="faculty_reporting_time"
                                v-model="responseData.weekly_report.faculty_reporting_time"/>
                            <i class="clear-input">
                                <ion-icon name="close-circle"></ion-icon>
                            </i>
                        </div>
                        <ErrorMessage name="faculty_reporting_time" class="error-feedback" />
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label" for="code">Refreshment</label>
                            <Field as="select" class="form-control custom-select" id="refreshment" name="refreshment"
                                v-model="responseData.weekly_report.refreshment">
                                <option value="" selected>---Select---</option>
                                <option value="Y">Yes</option>
                                <option value="N">No</option>
                            </Field>
                        </div>
                        <ErrorMessage name="refreshment" class="error-feedback" />
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label" for="pin">Module Taken</label>
                            <Field type="text" class="form-control" name="module_taken" placeholder="Module Taken"
                                v-model="responseData.weekly_report.module_taken"/>
                            <i class="clear-input">
                                <ion-icon name="close-circle"></ion-icon>
                            </i>
                        </div>
                        <ErrorMessage name="module_taken" class="error-feedback" />
                    </div>
                    <div class="transparent pt-3">
                        <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="btnLoading">
                            <span v-show="btnLoading" class="spinner-border spinner-border-sm"></span>
                            <span>Save</span>
                        </button>
                    </div>
                </div>

            </div>
        </Form>
    </div>
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
</template>
<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import UserService from "../../services/user.service";
import AlertModel from "../layouts/AlertModel.vue";
import DialogModel from "../layouts/DialogModel.vue";
export default {
    name: 'Organization',
    components: {
        Form,
        Field,
        ErrorMessage,
        AlertModel,
        DialogModel
    },
    data() {
        return {
            loading: false,
            minutes_loading: false,
            btnLoading: false,
            participant: [],
            member_list: [],
            alert_type: '',
            alert_message: '',
            dialog_message: '',
            dialog_action: '',
            dialog_action_params: [],
            tabD: true,
            tabP: false,
            tabA: false,
            tabM: false,
            tabH: false,
            tabMQ: false,
            tabMM: false,
            responseData: {
                center: [],
                participants: [],
                weekly_report: [],
            },
            centre_id: '',
            meeting_location: '',
            cre_date: '',
            starting_time: '',
            ending_time: '',
            faculty_reporting_time: '',
            refreshment: '',
            module_taken: '',
            message: "",
            selectedParticipants: [],
            batch_loading: false,
            selectAllChecked: false,
            user_level: "",
            permissions: [],
            sub_levels: [],
            sub_level_list_name: "",
            user_level_id: "",
            unit: [],
            nerpatham_target: '',
            sub_level_id: '',
            sub_level: [],
            questians_responses: [],
            agenda_assigned_member: ''
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        attendanceSummary() {
            const participants = this.responseData.participants || [];
            let present = 0;
            let absent = 0;
            participants.forEach((p) => {
                if (p.attendance === 'P') {
                    present += 1;
                } else if (p.attendance === 'A' || p.attendance === 'L') {
                    absent += 1;
                }
            });
            return {
                total: participants.length,
                present,
                absent,
                unmarked: participants.length - present - absent,
            };
        },
    },
    watch: {
        selectedParticipants() {
            const allIds = (this.responseData.participants || []).map((p) => p.id);
            this.selectAllChecked = allIds.length > 0
                && allIds.every((id) => this.selectedParticipants.includes(id));
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.centre_id = this.$route.params.id;
            this.user_level = this.currentUser.user_level;
            this.$root.updateParent("Loading...");
            if (this.user_level == 1) {
                this.user_level_id = 0;
            } else if (this.user_level == 2) {
                this.user_level_id = this.currentUser.district_id;
            }
            else if (this.user_level == 3) {
                this.user_level_id = this.currentUser.zone_id;
            }
            else if (this.user_level == 4) {
                this.user_level_id = this.currentUser.unit_id;
            }
            this.getCentreDetails(this.centre_id);
        }
    },
    methods: {
        goToTab(tab) {
            this.loading = true;
            this.tabD = false;
            this.tabP = false;
            this.tabA = false;
            this.tabM = false;
            this.tabH = false;
            if (tab == 'tabD') {
                this.tabD = true;
                // this.getMeetings('Details');
                this.loading = false;
            } else if (tab == 'tabP') {
                this.tabP = true;
                // this.getMeetings('Participants');
                this.loading = false;
            } else if (tab == 'tabA') {
                this.tabA = true;
                // this.getMeetings('Agenda');
                this.loading = false;
            } else if (tab == 'tabM') {
                this.tabM = true;
                // this.getMeetings('Minutes');
                this.loading = false;
            } else {
                this.tabH = true;
                // this.getMeetings('Minutes');
                this.loading = false;
            }
        },
        goToMinutesTab(tab) {
            this.minutes_loading = true;
            this.tabMM = false;
            this.tabMQ = false;
            if (tab == 'tabMM') {
                this.tabMM = true;
                this.minutes_loading = false;
            } else {
                this.tabMQ = true;
                this.minutes_loading = false;
            }
        },
        getTextList(event, type) {
            this.message = '';
            let data = {
                q: event,
                type: type,
                filter: 'all',
                user_level: 1
            }
            UserService.authPostRequest('get-typehead-values', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.member_list = response.data.data.list;
                    }
                },
                (error) => {
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getCentreDetails(id) {
            this.loading = true;
            let data = {
                id: id,
            }
            UserService.authPostRequest('show-cre-center-weekly-report', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.loading = false;
                        this.responseData = response.data.data;
                        if (!this.responseData.participants) {
                            this.responseData.participants = [];
                        }
                        this.selectedParticipants = [];
                        this.selectAllChecked = false;
                        this.$root.updateParent('CRE Weekly Report');
                    } else {
                        this.loading = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = 'Error';
                    this.alert_message = error.data.message;
                    this.$refs.alert_model.openModel();
                }
            );
        },

        reportDetailSave(data) {
            this.btnLoading = true;
            data.id = this.responseData.weekly_report.id;
            data.centre_id = this.centre_id;
            UserService.addAdmin('update-report-details', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.responseData = response.data.data;
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btnLoading = false;
                        this.message = '';
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btnLoading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btnLoading = false;
                    } else {
                        this.btnLoading = false;
                    }
                },
                (error) => {
                    this.alert_type = 'Error';
                    this.alert_message = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                    this.$refs.alert_model.openModel();
                    this.btnLoading = false;
                }
            );
        },

        attendanceLabel(attendance) {
            if (attendance === 'P') return 'Present';
            if (attendance === 'A') return 'Absent';
            if (attendance === 'L') return 'Leave';
            return 'Not marked';
        },
        statusPillClass(attendance) {
            if (attendance === 'P') return 'status-pill--present';
            if (attendance === 'A') return 'status-pill--absent';
            if (attendance === 'L') return 'status-pill--leave';
            return 'status-pill--pending';
        },
        studentCardClass(member) {
            const attendance = member.attendance;
            return {
                'student-card--present': attendance === 'P',
                'student-card--absent': attendance === 'A' || attendance === 'L',
                'student-card--pending': !attendance || attendance === 'N',
                'student-card--selected': this.selectedParticipants.includes(member.id),
            };
        },
        toggleSelectAll() {
            if (this.selectAllChecked) {
                this.selectedParticipants = (this.responseData.participants || []).map((p) => p.id);
            } else {
                this.selectedParticipants = [];
            }
        },
        toggleParticipantRow(id) {
            const ids = [...this.selectedParticipants];
            const idx = ids.indexOf(id);
            if (idx === -1) {
                ids.push(id);
            } else {
                ids.splice(idx, 1);
            }
            this.selectedParticipants = ids;
        },
        submitBatchAttendance(status) {
            if (!status) {
                return;
            }
            if (this.selectedParticipants.length === 0) {
                this.alert_type = 'Warning';
                this.alert_message = 'Please select at least one student.';
                this.$refs.alert_model.openModel();
                return;
            }

            this.batch_loading = true;

            const data = {
                centre_id: this.centre_id,
                participant_ids: this.selectedParticipants,
                attendance_status: status,
                remarks: ''
            };

            UserService.authPostRequest('store-batch-cre-attendance', data).then(
                (response) => {
                    if (response.data.status === 'success') {
                        if (response.data.data && response.data.data.participants) {
                            this.responseData.participants = response.data.data.participants;
                        } else {
                            this.responseData.participants.forEach((participant) => {
                                if (this.selectedParticipants.includes(participant.id)) {
                                    participant.attendance = status;
                                }
                            });
                        }
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message || `Attendance saved for ${this.selectedParticipants.length} student(s).`;
                        this.$refs.alert_model.openModel();
                        this.selectedParticipants = [];
                        this.selectAllChecked = false;
                    } else {
                        this.alert_type = response.data.status === 'warning' ? 'Warning' : 'Error';
                        this.alert_message = response.data.message || 'Failed to update attendance.';
                        this.$refs.alert_model.openModel();
                    }
                    this.batch_loading = false;
                },
                (error) => {
                    this.batch_loading = false;
                    this.alert_type = 'Error';
                    this.alert_message = (error.response && error.response.data && error.response.data.message)
                        || error.message
                        || 'Failed to update attendance.';
                    this.$refs.alert_model.openModel();
                }
            );
        },
    },
};
</script>
<style scoped>
.list-title {
    font-size: 16px;
    color: black;
}

.item {
    /* margin-bottom: 10px; */
}

.report-btn {
    width: 100% !important;
}

.add-member-btn {
    font-size: 16px !important;
    font-weight: 800 !important;
}

.wallet-footer-user {
    /* height: 46px !important; */
}

.text-only {
    font-size: 13px;
    font-weight: bold;
    color: black;
    /* margin-right: 5px; */
}


.chip-media {
    margin-left: 5px;
    width: 145px !important;
    padding-left: 25px !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.chip-icon {
    width: 50px !important;
}

.chip-label {
    padding: 0px 30px 0px 30px !important;
    font-size: 14px !important;
}

.bg-pink {
    background-color: #E6A6C7 !important;
}

.bg-pink-dark {
    background-color: #B85887 !important;
}


.wallet-card .wallet-footer .item .icon-wrapper {
    width: 100%;
    height: 48px;
    display: inline-flex;
    align-items: left;
    justify-content: left;
    border-radius: 10px;
    color: #fff;
    /* font-size: 28px; */
    margin-bottom: 14px;
    padding-left: 10px;
}

.menu-icon {
    font-size: 32px !important;
}

.menu-title {
    color: #fff !important;
    font-size: 12px !important;
    padding-left: 5px !important;
    text-align: left !important;
}

.back-color-primary {
    background: #1a418c !important;
}

.back-color-secondary {
    background: #666d79 !important;
}

.back-color-danger {
    background: #de6f56 !important;
}

.back-color-warning {
    background: #b19547 !important;
}

.back-color-red {
    background: #d55454 !important;
}

.back-color-violet {
    background: #072F5F !important;
}

.back-color-blue1 {
    background: #1a418c !important;
}

.back-color-blue2 {
    background: #1a418c !important;
}

.back-color-blue3 {
    background: #1a418c !important;
}

.back-color-blue4 {
    background: #1a418c !important;
}

.back-color-blue5 {
    background: #1a418c !important;
}

.back-color-blue6 {
    background: #1a418c !important;
}

.w-50 {
    width: 50px !important;
}

.goals .item {
    padding: 10px 10px;
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    margin-bottom: 10px;
}

.price-icon {
    /* margin-top: -1%; */
    font-size: 24px;
}

.chip-label[data-v-3bccde2f] {
    padding: 0px 5px 0px 5px !important;
    font-size: 14px !important;
}

.pad-5-left {
    padding-left: 5px;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.green-tick {
    font-size: 18px;
    color: darkgreen;
}

.red-cross {
    font-size: 18px;
    color: red;
}

.questians-label {
    font-weight: 600 !important;
    font-size: 14px !important;

}

.meeting-title {
    font-size: 20px !important;
}

.cre-attendance-panel {
    padding: 0 16px 100px;
}

.attendance-summary {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    margin-bottom: 12px;
}

.summary-chip {
    background: #fff;
    border: 1px solid #e8ecf1;
    border-radius: 10px;
    padding: 10px 8px;
    text-align: center;
    box-shadow: 0 1px 2px rgba(26, 65, 140, 0.06);
}

.summary-chip__value {
    display: block;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.2;
}

.summary-chip__label {
    display: block;
    font-size: 11px;
    color: #6b7280;
    margin-top: 2px;
    text-transform: uppercase;
    letter-spacing: 0.02em;
}

.summary-chip--present .summary-chip__value { color: #198754; }
.summary-chip--absent .summary-chip__value { color: #dc3545; }
.summary-chip--pending .summary-chip__value { color: #6c757d; }

.attendance-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    border: 1px solid #e8ecf1;
    border-radius: 10px;
    padding: 12px 14px;
    margin-bottom: 12px;
    box-shadow: 0 1px 2px rgba(26, 65, 140, 0.06);
}

.attendance-toolbar__select {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #1a418c;
    cursor: pointer;
}

.attendance-toolbar__count {
    font-size: 13px;
    color: #6b7280;
}

.attendance-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.student-card {
    display: flex;
    align-items: center;
    gap: 10px;
    background: #fff;
    border: 1px solid #e8ecf1;
    border-radius: 12px;
    padding: 10px 12px;
    cursor: pointer;
    transition: border-color 0.15s, box-shadow 0.15s;
    box-shadow: 0 1px 2px rgba(26, 65, 140, 0.04);
}

.student-card--present { border-left: 4px solid #198754; }
.student-card--absent { border-left: 4px solid #dc3545; }
.student-card--pending { border-left: 4px solid #d1d5db; }
.student-card--selected {
    border-color: #1a418c;
    box-shadow: 0 0 0 2px rgba(26, 65, 140, 0.15);
}

.student-card__check {
    display: flex;
    align-items: center;
    margin: 0;
    flex-shrink: 0;
}

.student-card__avatar {
    position: relative;
    flex-shrink: 0;
}

.student-card__avatar-img {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    object-fit: cover;
}

.student-card__index {
    position: absolute;
    bottom: -2px;
    right: -2px;
    min-width: 18px;
    height: 18px;
    padding: 0 4px;
    border-radius: 9px;
    background: #1a418c;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    line-height: 18px;
    text-align: center;
}

.student-card__body {
    flex: 1;
    min-width: 0;
}

.student-card__row-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 4px;
}

.student-card__name {
    font-size: 15px;
    font-weight: 600;
    color: #111827;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.student-card__row-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

.student-card__phone {
    font-size: 13px;
    color: #6b7280;
}

.student-card__actions {
    display: flex;
    gap: 6px;
    flex-shrink: 0;
}

.action-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: #f0f4fa;
    color: #1a418c;
    font-size: 18px;
}

.action-icon--whatsapp {
    background: #e8f8ee;
    color: #25d366;
}

.status-pill {
    flex-shrink: 0;
    font-size: 11px;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 20px;
    text-transform: uppercase;
    letter-spacing: 0.02em;
}

.status-pill--present { background: #d1e7dd; color: #0f5132; }
.status-pill--absent { background: #f8d7da; color: #842029; }
.status-pill--leave { background: #fff3cd; color: #664d03; }
.status-pill--pending { background: #e9ecef; color: #495057; }

.attendance-bulk-bar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 56px;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 16px;
    background: #fff;
    border-top: 1px solid #e8ecf1;
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.08);
    transform: translateY(100%);
    opacity: 0;
    pointer-events: none;
    transition: transform 0.2s ease, opacity 0.2s ease;
}

.attendance-bulk-bar.is-visible {
    transform: translateY(0);
    opacity: 1;
    pointer-events: auto;
}

.attendance-bulk-bar__count {
    font-size: 14px;
    font-weight: 600;
    color: #1a418c;
    white-space: nowrap;
}

.attendance-bulk-bar__actions {
    display: flex;
    gap: 8px;
    flex: 1;
    justify-content: flex-end;
}

.attendance-bulk-bar .btn-present,
.attendance-bulk-bar .btn-absent {
    min-width: 96px;
    padding: 10px 16px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #fff;
}

.attendance-bulk-bar .btn-present {
    background: #198754;
}

.attendance-bulk-bar .btn-absent {
    background: #dc3545;
}

.attendance-bulk-bar .btn-present:disabled,
.attendance-bulk-bar .btn-absent:disabled {
    opacity: 0.65;
}

.cre-attendance-check {
    width: 20px !important;
    height: 20px !important;
    min-width: 20px !important;
    min-height: 20px !important;
    margin: 0 !important;
    accent-color: #1a418c;
    cursor: pointer;
}
</style>
<!-- Unscoped: ensure checkboxes stay visible on mobile theme -->
<style>
.cre-attendance-panel .cre-attendance-check,
.cre-attendance-panel input[type="checkbox"].cre-attendance-check {
    width: 20px !important;
    height: 20px !important;
    opacity: 1 !important;
    visibility: visible !important;
    display: inline-block !important;
    -webkit-appearance: checkbox !important;
    appearance: checkbox !important;
    position: static !important;
    pointer-events: auto !important;
}
</style>